document.addEventListener('DOMContentLoaded', function() {
    const shapeInputs = {
        'rectangle': ['Length', 'Width', 'Height'],
        'cube': ['Side Length'],
        'hexagon': ['Length', 'Width', 'Height', 'Front Pane'],
        'octagon': ['Length', 'Width', 'Height', 'Front Pane', 'End Pane'],
        'flatBackHexagon': ['Length', 'Width', 'Height', 'Front Pane', 'End Pane'],
        'cylinder': ['Radius', 'Height'],
        'halfCylinder': ['Radius', 'Height'],
        'cornerCylinder': ['Radius', 'Height'],
        'elliptical': ['Radius 1', 'Radius 2', 'Height'],
        'cornerPentagon': ['Length Long Side', 'Length Short Side', 'Height'],
        'lShaped': ['Length 1', 'Width 1', 'Length 2', 'Width 2', 'Height'],
        'cornerPrism': ['Length 1', 'Length 2', 'Height']
    };

    const shapeImages = {
        'rectangle': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-RectangleFull.jpg?v=1747672321',
        'cube': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CubeFull.jpg?v=1747672321',
        'hexagon': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-HexagonFull.jpg?v=1747672321',
        'octagon': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-OctogonFull.jpg?v=1747672321',
        'flatBackHexagon': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-FlatBackHexagonFull.jpg?v=1747672321',
        'cylinder': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CylinderFull.jpg?v=1747672321',
        'halfCylinder': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-HalfCylinderFull.jpg?v=1747672321',
        'cornerCylinder': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerPentagonFull.jpg?v=1747672321',
        'elliptical': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-EllipticalFull.jpg?v=1747672321',
        'cornerPentagon': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerPrismFull.jpg?v=1747672321',
        'lShaped': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-LShapedFull.jpg?v=1747672321',
        'cornerPrism': 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerPrismFull.jpg?v=1747672321'
    };

    const shapeNames = {
        'rectangle': 'Rectangle',
        'cube': 'Cube',
        'hexagon': 'Hexagon',
        'octagon': 'Octagon',
        'flatBackHexagon': 'Flat Back Hexagon',
        'cylinder': 'Cylinder',
        'halfCylinder': 'Half Cylinder',
        'cornerCylinder': 'Corner Cylinder',
        'elliptical': 'Elliptical',
        'cornerPentagon': 'Corner Pentagon',
        'lShaped': 'L-Shaped',
        'cornerPrism': 'Corner Prism'
    };

    const unitToggle = document.getElementById('unitToggle');
    const customDropdown = document.getElementById('customDropdown');
    const dropdownText = document.getElementById('dropdownText');
    const shapeMiniIcons = document.getElementById('shapeMiniIcons');
    const selectedShapeImage = document.getElementById('selectedShapeImage');

    if (!unitToggle || !customDropdown || !dropdownText || !shapeMiniIcons || !selectedShapeImage) {
        console.error('Required DOM elements not found for Volume Calculator');
        return;
    }

    let currentUnit = 'imperial'; // Track unit state manually
    let selectedShape = 'rectangle'; // Default shape
    let isMiniIconsOpen = false; // Track the state of the mini icon section

    // Update the displayed image when the shape changes
    function updateShapeImage() {
        const img = selectedShapeImage.querySelector('img');
        img.src = shapeImages[selectedShape];
        img.alt = `Selected shape: ${shapeNames[selectedShape]}`;
    }

    // Update the custom dropdown's displayed text
    function updateShapeSelectDisplay() {
        dropdownText.textContent = shapeNames[selectedShape];
    }

    // Toggle the mini icons section visibility
    function toggleMiniIcons() {
        isMiniIconsOpen = !isMiniIconsOpen;
        if (isMiniIconsOpen) {
            shapeMiniIcons.classList.add('active');
        } else {
            shapeMiniIcons.classList.remove('active');
        }
    }

    // Shape selection functionality via custom dropdown
    customDropdown.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent this click from bubbling up to the document
        toggleMiniIcons(); // Toggle mini icons section
    });

    // Close mini icons section when clicking outside
    document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target) && !shapeMiniIcons.contains(e.target)) {
            isMiniIconsOpen = false;
            shapeMiniIcons.classList.remove('active');
        }
    });

    // Prevent clicks inside the mini icon section from closing it
    shapeMiniIcons.addEventListener('click', function(e) {
        e.stopPropagation();
    });

    // Shape selection via mini icons
    const shapeMiniOptions = shapeMiniIcons.getElementsByClassName('shape-mini-option');
    for (let option of shapeMiniOptions) {
        option.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent the click from bubbling up and closing the section immediately
            selectedShape = this.getAttribute('data-shape');
            updateShapeImage();
            updateShapeSelectDisplay();
            updateInputs();
            isMiniIconsOpen = false;
            shapeMiniIcons.classList.remove('active'); // Close the mini icons section
        });
    }

    function updateUnitLabel() {
        const previousUnit = currentUnit;
        currentUnit = unitToggle.checked ? 'metric' : 'imperial';
        
        // Convert existing values in input fields
        const inputsDiv = document.getElementById('inputs');
        const shapeInputs = inputsDiv.getElementsByTagName('input');

        // Convert shape dimensions
        for (let input of shapeInputs) {
            const value = input.value ? parseFloat(input.value) : null;
            if (value !== null) {
                if (previousUnit === 'imperial' && unitToggle.checked) {
                    // Inches to centimeters
                    input.value = (value * 2.54).toFixed(2);
                } else if (previousUnit === 'metric' && !unitToggle.checked) {
                    // Centimeters to inches
                    input.value = (value / 2.54).toFixed(2);
                }
            }
        }

        updateInputs();
    }

    function updateInputs() {
        const shape = selectedShape;
        const unit = unitToggle.checked ? 'metric' : 'imperial';
        const inputsDiv = document.getElementById('inputs');
        if (!inputsDiv) {
            console.error('Inputs div not found');
            return;
        }
        const existingValues = {};
        const existingInputs = inputsDiv.getElementsByTagName('input');
        for (let input of existingInputs) {
            existingValues[input.id] = input.value ? parseFloat(input.value) : null;
        }

        inputsDiv.innerHTML = '';

        const inputs = shapeInputs[shape];
        inputs.forEach((inputLabel) => {
            const label = document.createElement('label');
            label.textContent = `${inputLabel} (${unit === 'imperial' ? 'in' : 'cm'}):`;
            const input = document.createElement('input');
            input.type = 'number';
            input.id = inputLabel.toLowerCase().replace(/ /g, '_');
            input.min = '0';
            input.step = '0.1';
            input.placeholder = `Enter ${inputLabel.toLowerCase()} in ${unit === 'imperial' ? 'inches' : 'centimeters'}`;
            input.setAttribute('aria-label', `Enter ${inputLabel.toLowerCase()} in ${unit === 'imperial' ? 'inches' : 'centimeters'}`);
            input.required = true;
            if (existingValues[input.id] !== null && !isNaN(existingValues[input.id])) {
                input.value = existingValues[input.id];
            }
            input.addEventListener('input', calculateVolume);
            inputsDiv.appendChild(label);
            inputsDiv.appendChild(input);
            inputsDiv.appendChild(document.createElement('br'));
        });

        calculateVolume();
    }

    unitToggle.addEventListener('change', updateUnitLabel);
    updateInputs();

    function calculateVolume() {
        const shape = selectedShape;
        const unit = unitToggle.checked ? 'metric' : 'imperial';
        const inputs = {};
        shapeInputs[shape].forEach((inputLabel) => {
            const id = inputLabel.toLowerCase().replace(/ /g, '_');
            const inputElement = document.getElementById(id);
            const value = inputElement ? inputElement.value : null;
            inputs[id] = value ? parseFloat(value) : null;
        });

        const volumeResultDiv = document.getElementById('volumeResult');
        if (!volumeResultDiv) {
            console.error('Volume Result div not found');
            return;
        }

        let volume;
        switch (shape) {
            case 'rectangle':
                if (!inputs['length'] || !inputs['width'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = inputs['length'] * inputs['width'] * inputs['height'];
                break;
            case 'cube':
                if (!inputs['side_length']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = Math.pow(inputs['side_length'], 3);
                break;
            case 'cylinder':
                if (!inputs['radius'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = Math.PI * Math.pow(inputs['radius'], 2) * inputs['height'];
                break;
            case 'halfCylinder':
                if (!inputs['radius'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = (Math.PI * Math.pow(inputs['radius'], 2) * inputs['height']) / 2;
                break;
            case 'cornerCylinder':
                if (!inputs['radius'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = (Math.PI * Math.pow(inputs['radius'], 2) * inputs['height']) / 4;
                break;
            case 'hexagon':
                if (!inputs['length'] || !inputs['width'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                if (inputs['front_pane'] && inputs['front_pane'] <= inputs['width']) {
                    const s = inputs['front_pane'];
                    const base_area = (3 * Math.sqrt(3) / 2) * (s ** 2);
                    volume = base_area * inputs['height'];
                } else {
                    volume = inputs['length'] * inputs['width'] * inputs['height'] * 1.0;
                }
                break;
            case 'octagon':
                if (!inputs['length'] || !inputs['width'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = inputs['length'] * inputs['width'] * inputs['height'];
                break;
            case 'flatBackHexagon':
                if (!inputs['length'] || !inputs['width'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                const factor = (inputs['front_pane'] && inputs['end_pane'] && 
                               inputs['front_pane'] <= inputs['width'] && 
                               inputs['end_pane'] <= inputs['width']) ? 1.0 : 0.824;
                volume = inputs['length'] * inputs['width'] * inputs['height'] * factor;
                break;
            case 'elliptical':
                if (!inputs['radius_1'] || !inputs['radius_2'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = Math.PI * inputs['radius_1'] * inputs['radius_2'] * inputs['height'];
                break;
            case 'cornerPentagon':
                if (!inputs['length_long_side'] || !inputs['length_short_side'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = inputs['length_long_side'] * inputs['length_short_side'] * inputs['height'];
                break;
            case 'lShaped':
                if (!inputs['length_1'] || !inputs['width_1'] || !inputs['length_2'] || !inputs['width_2'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                const overlap_area = Math.min(inputs['width_1'], inputs['length_2']) * Math.min(inputs['length_1'], inputs['width_2']);
                const base_area = (inputs['length_1'] * inputs['width_1']) + (inputs['length_2'] * inputs['width_2']) - overlap_area;
                volume = base_area * inputs['height'];
                break;
            case 'cornerPrism':
                if (!inputs['length_1'] || !inputs['length_2'] || !inputs['height']) {
                    volumeResultDiv.innerHTML = '';
                    return;
                }
                volume = (inputs['length_1'] * inputs['length_2'] * inputs['height']) / 2;
                break;
            default:
                volume = 0;
        }

        // Display the volume
        // Display the volume in gallons or liters
        if (volume > 0) {
            if (unit === 'imperial') {
                const gallons = volume / 231;
                volumeResultDiv.innerHTML = `${gallons.toFixed(2)} gallons`;
            } else {
                const liters = volume / 1000;
                const gallons = liters * 0.264172;
                volumeResultDiv.innerHTML = `${gallons.toFixed(2)} gallons`;
            }
        } else {
            volumeResultDiv.innerHTML = '';
        }
    }
});